import { DualListSelect } from './DualListSelect';

export default DualListSelect;
